<template>
  <div class="qm-business-state">
    <i v-if="visibleDot" class="qm-business-state__dot" :style="{ backgroundColor: $currentInfo.color }"></i>
    <span class="qm-business-state__text">{{ $currentInfo.text }}</span>
  </div>
</template>

<script>
export default {
  name: 'QmBusinessState',
  props: {
    current: {
      type: [Number, String],
      required: true,
    },
    option: {
      type: Object,
      required: true,
    },
    visibleDot: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    $currentInfo() {
      const currentInfo = this.option[this.current]

      return {
        color: currentInfo ? currentInfo.color : 'transparent',
        text: currentInfo ? currentInfo.text : '--',
      }
    },
  },
}
</script>
